import '@babel/polyfill';
import Vue from 'vue';
import './plugins/vuetify';
import Provider from './Provider.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';

import Brace from '@/components/BraceEditor';

Vue.config.productionTip = false;

Vue.use(require('vue-shortkey'));
Vue.component('brace', Brace);

router.beforeEach((to, from, next) => {
	if (to.meta.policy.includes(store.getters.userType)) {
		next();
	} else {
		// console.log('-- Blocked route')
	}
});

new Vue({
	router,
	store,
	render: h => h(Provider),
}).$mount('#app');
